package fr.frux.feature.treeadd

import fr.frux.core.common.logging.Logger
import fr.frux.core.common.prefs.AppPreferences
import fr.frux.core.common.result.runCatchingCancellable

internal const val TREE_ADD_INTRO_SEEN_KEY = "treeadd_intro_seen"

/**
 * Mémoire de l'introduction « Que puis-je recenser ? » (spec onboarding de contribution §3).
 * Une lecture ratée vaut « déjà vue » : un stockage cassé ne doit pas rouvrir l'aide à chaque
 * ajout, elle reste accessible par son lien.
 */
class TreeAddIntroStore(
    private val preferences: AppPreferences,
) {
    suspend fun isSeen(): Boolean =
        runCatchingCancellable { preferences.getBoolean(TREE_ADD_INTRO_SEEN_KEY, false) }
            .onFailure { Logger.e(TAG, "Lecture de l'introduction impossible", it) }
            .getOrDefault(true)

    suspend fun markSeen() {
        runCatchingCancellable { preferences.putBoolean(TREE_ADD_INTRO_SEEN_KEY, true) }
            .onFailure { Logger.e(TAG, "Écriture de l'introduction impossible", it) }
    }

    private companion object {
        const val TAG = "TreeAddIntroStore"
    }
}
